import React, { useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  form: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '100%',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));




const UpdatePasswordForm = () => {

    const classes = useStyles();
  const [formData, setFormData] = useState({
    email: '',
    oldPassword: '',
    newPassword: '',
    repeatPassword: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value.trim() }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if any field is empty
    if (Object.values(formData).some((value) => value === '')) {
      alert('Please fill in all fields');
      return;
    }

    // Additional validation logic can be added here

    // Submit the form
    console.log('Form submitted:', formData);
  };


  return (
    <div  className="con-dev flex justify-center items-center" style={{width:"100%",height:"100%"}}>
       
       
          <Paper className={classes.paper}>
            <Typography variant="h6" gutterBottom>
              Change Password
            </Typography>
            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                label="Email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <TextField
                label="Old Password"
                type="password"
                name="oldPassword"
                value={formData.oldPassword}
                onChange={handleChange}
                required
              />
              <TextField
                label="New Password"
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                required
              />
              <TextField
                label="Repeat New Password"
                type="password"
                name="repeatPassword"
                value={formData.repeatPassword}
                onChange={handleChange}
                required
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={classes.button}
              >
                Update
              </Button>
            </form>
          </Paper>
        
    
    </div>
  );
};

export default UpdatePasswordForm;


// get_data_adminuser